module.exports = __webpack_public_path__ + "static/media/table_tablet_highlight.2afb11d1.svg";